import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cdd8890e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-testid": "import-form-step",
  class: "flex flex-col gap-y-4 py-2 form-step"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Empresa "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Unidade "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Escala(s) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "flex items-center gap-2 text-sm",
  style: {"color":"rgb(var(--v-theme-error))"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Erro ao carregar escalas.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-textPrimary text-left" }, " As importações de avaliação de políticas são feitas através de um arquivo .csv, que deve ser anexo nessa página. ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-textPrimary text-left" }, [
  /*#__PURE__*/_createTextVNode(" O arquivo deve respeitar o layout de colunas do modelo disponível abaixo. Veja "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/docs/import-templates-guide.md",
    target: "_blank",
    class: "text-primary20 underline"
  }, " guia de formato "),
  /*#__PURE__*/_createTextVNode(" para detalhes sobre colunas e valores válidos. ")
], -1))

import { ref, computed, watch, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { mdiDownload } from '@mdi/js'
import { useErrorToast } from '@/composables/useErrorToast'

import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import { useCompanyStore } from '@/pinia-store/useCompanyStore'
import { useHealthUnitStore } from '@/pinia-store/useHealthUnitStore'
import { useImportQualificationValidationsStore } from '@/pinia-store/useImportQualificationValidationsStore'
import { useScheduleStore } from '@/pinia-store/useScheduleStore'
import type { ImportFormData, QualificationPolicyType } from './types'
import { DEFAULT_POLICY_TYPE } from './types'


export default /*#__PURE__*/_defineComponent({
  __name: 'StepForm',
  props: {
    modelValue: {},
    valid: { type: Boolean },
    policyType: { default: DEFAULT_POLICY_TYPE }
  },
  emits: ["update:modelValue", "update:valid"],
  setup(__props: any, { emit }) {

const props = __props;





const companyStore = useCompanyStore()
const healthUnitStore = useHealthUnitStore()
const importStore = useImportQualificationValidationsStore()
const scheduleStore = useScheduleStore()

const { listCompanies } = storeToRefs(companyStore)
const { listHealthUnitsByCompany } = storeToRefs(healthUnitStore)
const { listSchedules } = storeToRefs(scheduleStore)

const { notifyError, notifyErrorMessage } = useErrorToast()
const isLoadingUnits = ref(false)
const isLoadingSchedules = ref(false)
const conflictsLoadFailed = ref(false)
const { scheduleConflicts } = storeToRefs(importStore)
const requestIds = { units: 0, schedules: 0 }

const scheduleItems = computed(() =>
  listSchedules.value.map((item) => {
    const conflict = scheduleConflicts.value[Number(item.value)]
    if (!conflict) return item
    return {
      ...item,
      title: `${item.title} (já possui política ativa e vigente)`,
      props: { disabled: true }
    }
  })
)

const updateForm = (partial: Partial<ImportFormData>) => {
  emit('update:modelValue', { ...props.modelValue, ...partial })
}

const isValid = computed(
  () =>
    props.modelValue.company !== null &&
    props.modelValue.healthUnit !== null &&
    props.modelValue.schedules.length > 0
)

watch(isValid, (val) => emit('update:valid', val), { immediate: true })

const companyValue = computed<string | null>({
  get: () => (props.modelValue.company !== null ? String(props.modelValue.company) : null),
  set: (val) => {
    const num = Number(val)
    const company = val !== null && val !== undefined && !isNaN(num) ? num : null
    updateForm({ company, healthUnit: null, schedules: [] })
    handleCompanyChange(company)
  }
})

const healthUnitValue = computed<string | null>({
  get: () => (props.modelValue.healthUnit !== null ? String(props.modelValue.healthUnit) : null),
  set: (val) => {
    const num = Number(val)
    const healthUnit = val !== null && val !== undefined && !isNaN(num) ? num : null
    updateForm({ healthUnit, schedules: [] })
    handleHealthUnitChange(healthUnit)
  }
})

const scheduleValues = computed<string[]>({
  get: () => props.modelValue.schedules.map(String),
  set: (val) => {
    updateForm({ schedules: val.map(Number) })
  }
})

const handleCompanyChange = async (companyId: number | null) => {
  const requestId = ++requestIds.units
  scheduleConflicts.value = {}
  scheduleStore.setSchedulesByHealthUnit(null)
  if (!companyId) {
    healthUnitStore.setHealthUnitsByCompany(null)
    return
  }
  isLoadingUnits.value = true
  // Sem catch: `setHealthUnitsByCompany` trata a falha na própria store (toast + lista
  // vazia) e nunca rejeita — um catch aqui seria código morto e duplicaria o toast.
  try {
    await healthUnitStore.setHealthUnitsByCompany(companyId)
  } finally {
    if (requestId === requestIds.units) isLoadingUnits.value = false
  }
}

const handleHealthUnitChange = async (healthUnitId: number | null) => {
  const requestId = ++requestIds.schedules
  scheduleConflicts.value = {}
  if (!healthUnitId) {
    scheduleStore.setSchedulesByHealthUnit(null)
    return
  }
  isLoadingSchedules.value = true
  conflictsLoadFailed.value = false
  try {
    await scheduleStore.setSchedulesByHealthUnit(healthUnitId)
    if (requestId === requestIds.schedules && props.modelValue.company) {
      await fetchConflictsAndFilter()
    }
  } catch (error) {
    notifyError(error, 'Erro ao carregar escalas.')
  } finally {
    if (requestId === requestIds.schedules) isLoadingSchedules.value = false
  }
}

const fetchConflictsAndFilter = async () => {
  if (!props.modelValue.company) return
  const allIds = listSchedules.value.map((s) => Number(s.value))
  try {
    await importStore.fetchScheduleConflicts(props.modelValue.company, allIds, props.policyType)
    conflictsLoadFailed.value = false
    const conflictingIds = new Set(Object.keys(scheduleConflicts.value).map(Number))
    const filtered = props.modelValue.schedules.filter((id) => !conflictingIds.has(id))
    if (filtered.length !== props.modelValue.schedules.length) {
      updateForm({ schedules: filtered })
    }
  } catch {
    conflictsLoadFailed.value = true
    updateForm({ schedules: [] })
  }
}

const retryConflictsCheck = async () => {
  isLoadingSchedules.value = true
  try {
    await fetchConflictsAndFilter()
  } finally {
    isLoadingSchedules.value = false
  }
}

const templatePath = computed(() =>
  props.policyType === 'DOCUMENTARY_QUALIFICATION'
    ? '/qualificacao-documental/importacao_documental_modelo.csv'
    : '/qualificacao-repasse/importacao_repasse_modelo.csv'
)

const downloadFileName = computed(() =>
  props.policyType === 'DOCUMENTARY_QUALIFICATION'
    ? 'importacao_documental_modelo.csv'
    : 'importacao_repasse_modelo.csv'
)

const handleDownloadTemplate = async () => {
  try {
    const response = await fetch(templatePath.value)
    if (!response.ok) throw new Error(`HTTP ${response.status}`)
    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', downloadFileName.value)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  } catch {
    // Sem `notifyError`: o modelo é um arquivo estático do próprio app (`public/`), não
    // uma chamada ao backend — não há mensagem de API a extrair, a frase fixa é a correta.
    notifyErrorMessage('Erro ao baixar modelo de importação.')
  }
}

onMounted(() => {
  if (!listCompanies.value.length) {
    companyStore.getMyCompanies()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_autocomplete, {
      modelValue: companyValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((companyValue).value = $event)),
      "data-testid": "import-form-empresa-select",
      label: "Empresa",
      items: _unref(listCompanies),
      variant: "outlined",
      density: "comfortable",
      "hide-details": "auto",
      color: "primary20"
    }, {
      label: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["modelValue", "items"]),
    _createVNode(_component_v_autocomplete, {
      modelValue: healthUnitValue.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((healthUnitValue).value = $event)),
      "data-testid": "import-form-unidade-select",
      items: _unref(listHealthUnitsByCompany),
      variant: "outlined",
      density: "comfortable",
      "hide-details": "auto",
      color: "primary20",
      disabled: !_ctx.modelValue.company || isLoadingUnits.value,
      loading: isLoadingUnits.value
    }, {
      label: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["modelValue", "items", "disabled", "loading"]),
    _createVNode(_component_v_autocomplete, {
      modelValue: scheduleValues.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((scheduleValues).value = $event)),
      "data-testid": "import-form-escala-select",
      items: scheduleItems.value,
      variant: "outlined",
      density: "comfortable",
      "hide-details": "auto",
      color: "primary20",
      multiple: "",
      chips: "",
      "closable-chips": "",
      disabled: !_ctx.modelValue.healthUnit || isLoadingSchedules.value || conflictsLoadFailed.value,
      loading: isLoadingSchedules.value
    }, {
      label: _withCtx(() => [
        _hoisted_4
      ]),
      item: _withCtx(({ props: itemProps }) => [
        _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(itemProps)), {
          prepend: _withCtx(({ isActive }) => [
            _createVNode(_component_v_checkbox_btn, {
              "model-value": isActive,
              color: "primary20"
            }, null, 8, ["model-value"])
          ]),
          _: 2
        }, 1040)
      ]),
      _: 1
    }, 8, ["modelValue", "items", "disabled", "loading"]),
    (conflictsLoadFailed.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("button", {
            type: "button",
            class: "retry-link",
            "data-testid": "import-conflicts-retry",
            onClick: retryConflictsCheck
          }, " Tente novamente ")
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_divider, { class: "my-1" }),
    _hoisted_7,
    _hoisted_8,
    _createVNode(OutlinedButton, {
      "data-testid": "import-form-download-modelo-button",
      text: "Download do modelo",
      "prepend-icon": _unref(mdiDownload),
      title: "Baixa um arquivo CSV com headers e exemplo de linha. Preencha, salve como CSV (ponto-e-vírgula) e faça upload.",
      class: "!border-primary30 !text-primary30 !font-bold self-start",
      onClick: handleDownloadTemplate
    }, null, 8, ["prepend-icon"])
  ]))
}
}

})